import _get from 'lodash.get';
import getProcessors from '../getProcessors';
import concatPath from '../concatPath';
var checkValue = function checkValue(path, value) {
  if (value === undefined) {
    throw new ReferenceError("no data exists at path \"".concat(path, "\""));
  }
};
var getPathValue = function getPathValue(_ref) {
  var finalPath = _ref.finalPath,
    storeValue = _ref.storeValue;
  return finalPath === '' ? storeValue : _get(storeValue, finalPath);
};
var applyResolversToPath = function applyResolversToPath(_ref2) {
  var resolvers = _ref2.resolvers,
    storeParams = _ref2.storeParams,
    localParams = _ref2.localParams,
    storeValue = _ref2.storeValue,
    path = _ref2.path,
    custom = _ref2.custom;
  return resolvers.reduce(function (pathSegment, resolver) {
    return resolver({
      storeParams: storeParams,
      localParams: localParams,
      storeValue: storeValue,
      originalPath: path,
      path: pathSegment,
      custom: custom
    });
  }, path);
};
var applyTransformersToValue = function applyTransformersToValue(_ref3) {
  var transformers = _ref3.transformers,
    storeParams = _ref3.storeParams,
    localParams = _ref3.localParams,
    storeValue = _ref3.storeValue,
    path = _ref3.path,
    finalPath = _ref3.finalPath,
    pathValue = _ref3.pathValue,
    custom = _ref3.custom;
  return transformers.reduce(function (currentValue, transformer) {
    return transformer({
      storeParams: storeParams,
      localParams: localParams,
      storeValue: storeValue,
      originalPath: path,
      path: finalPath,
      originalValue: pathValue,
      value: currentValue,
      custom: custom
    });
  }, pathValue);
};
var extractText = function extractText(_ref4) {
  var storeParams = _ref4.storeParams,
    localParams = _ref4.localParams,
    storeValue = _ref4.storeValue,
    basePath = _ref4.basePath,
    localPath = _ref4.localPath,
    resolverMap = _ref4.resolverMap,
    transformerMap = _ref4.transformerMap,
    resolverIds = _ref4.resolverIds,
    transformerIds = _ref4.transformerIds,
    custom = _ref4.custom;
  var path = concatPath(basePath, localPath);
  var resolvers = getProcessors(resolverMap, resolverIds, 'resolver');
  var transformers = getProcessors(transformerMap, transformerIds, 'transformer');
  var finalPath = applyResolversToPath({
    resolvers: resolvers,
    storeParams: storeParams,
    localParams: localParams,
    storeValue: storeValue,
    path: path,
    custom: custom
  });
  var pathValue = getPathValue({
    finalPath: finalPath,
    storeValue: storeValue
  });
  checkValue(finalPath, pathValue);
  return applyTransformersToValue({
    transformers: transformers,
    storeParams: storeParams,
    localParams: localParams,
    storeValue: storeValue,
    path: path,
    finalPath: finalPath,
    pathValue: pathValue,
    custom: custom
  });
};
export default extractText;